import { FormControl, FormLabel, FormErrorMessage, FormControlProps, InputGroup } from '@chakra-ui/react';
import { Field, FieldProps, ErrorMessage, FieldAttributes } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ReactSelect from 'components/ReactSelect';

export interface IFormikSelectProps {
  labelProps?: any;
  label?: string;
  name: string;
  options: Array<ILabelValueOptions>;
  onChangeCallback?: (value: any) => void;
  formControlProps?: FormControlProps;
  inputElement?: React.ReactNode;
  selectProps?: any;
  isLoading?: boolean;
  fieldProps?: FieldAttributes<any>;
}

const FormikSelect: React.FC<IFormikSelectProps> = ({
  label,
  labelProps,
  name,
  formControlProps,
  inputElement,
  options,
  onChangeCallback,
  selectProps,
  fieldProps,
}) => {
  const { t } = useTranslation();
  return (
    <Field name={name} {...fieldProps}>
      {({ field, form, meta }: FieldProps) => {
        return (
          <FormControl mb="6" {...formControlProps} id={name} isInvalid={(meta.error && meta.touched) || false}>
            {label && (
              <FormLabel
                htmlFor={name}
                color="gray.500"
                fontSize="12px"
                fontWeight="600"
                mb="1"
                textTransform="uppercase"
                {...labelProps}
              >
                {label}
              </FormLabel>
            )}
            <InputGroup size="lg">
              <ReactSelect
                isClearable
                {...field}
                options={options}
                error={(meta.error && meta.touched) || false}
                size="lg"
                variant="filled"
                fontSize="sm"
                onBlur={() => {
                  form.setFieldTouched(name, true);
                }}
                onChange={(e: any) => {
                  form.setFieldValue(name, e);
                  if (onChangeCallback) {
                    onChangeCallback(e);
                  }
                }}
                isSearchable
                {...selectProps}
              />
              {inputElement && inputElement}
            </InputGroup>
            <ErrorMessage
              name={name}
              render={(error: any) => {
                return <FormErrorMessage fontSize="13px">{t(error.msg, { value: error.value })}</FormErrorMessage>;
              }}
            />
          </FormControl>
        );
      }}
    </Field>
  );
};

export default FormikSelect;
